var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-card-wrapper",class:_vm.wrapperClass},[_c('div',{staticClass:"theme-card-title"},[_vm._t("title")],2),_c('div',{staticClass:"theme-card-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }